import { getToken, VatDetail } from "@/scripts/Common";
import { ApiResponse, defaultFetch, httpMethod } from "@/scripts/Common/api";

const fetchVatDetails = () : Promise<ApiResponse<VatDetail[]>> => defaultFetch(
{
  apiName: 'vatDetails',
  options: {
    method: httpMethod.GET,
    query: {pageSize: 9000} // vat settings does not have pagination (and probably never will have one), so we set a large number
  },
  bearer: getToken()
});

const createVatDetail = (vatDetail: VatDetail) : Promise<ApiResponse<VatDetail>> => defaultFetch(
{
  apiName: 'vatDetails',
  options: {
    method: httpMethod.POST,
  },
  body: JSON.stringify(vatDetail),
  bearer: getToken()
});

const deleteVatDetail = (id : number) : Promise<{error : any}> => defaultFetch(
{
  apiName: 'vatDetails',
  options: {
    method: httpMethod.DELETE,
    query: {id: id.toString()}
  },
  bearer: getToken()
});

export {
  fetchVatDetails,
  deleteVatDetail,
  createVatDetail
}
